import { render } from "./popupcommon.vue?vue&type=template&id=215347e0"
import script from "./popupcommon.vue?vue&type=script&lang=js"
export * from "./popupcommon.vue?vue&type=script&lang=js"

import exportComponent from "C:\\thangpn\\code\\free\\frontend-amber-hills\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__